import SlideView from './slide-view';
import './styles/index.scss';
export default SlideView;
